import { render } from "./CategorySelectCheckbox.vue?vue&type=template&id=d66b6d1c"
import script from "./CategorySelectCheckbox.vue?vue&type=script&lang=js"
export * from "./CategorySelectCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__